import React from "react"
import PropTypes from "prop-types"
import { Modal } from "antd"

import { Markdown } from "@components/Text"

const LABEL_YES = "Yes, my custodian has sent the funds"
const LABEL_TITLE = "Confirm Custodian Wire Request"
const LABEL_CONFIRM = `Clicking this button **does not** notify or debit your
SDIRA custodian or initiate a bank debit.

Please click **only after** you have instructed your custodian to wire the
funds using the provided instructions.

Once you confirm, your funding status will move to **Processing**. We’ll notify
you when the funds arrive.`


const InvestmentFundedCustodianModal = ({
  onOk,
  isOpen,
  onCancel,
  isLoading,
}) => {
  const modalProps = {
    open: isOpen,
    title: LABEL_TITLE,
    okText: LABEL_YES,
    confirmLoading: isLoading,
    onOk,
    onCancel,
  }

  return (
    <Modal {...modalProps}>
      <Markdown
        text={LABEL_CONFIRM}
      />
    </Modal>
  )
}

InvestmentFundedCustodianModal.propTypes = {
  onOk: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default InvestmentFundedCustodianModal
